import { render, staticRenderFns } from "./formAppendixVisa.vue?vue&type=template&id=0dbdefc4&scoped=true"
import script from "./formAppendixVisa.vue?vue&type=script&lang=js"
export * from "./formAppendixVisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbdefc4",
  null
  
)

export default component.exports